import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * True when the signed-in user is a Huelo team member (@huelo.co email).
 * Used to gate features that are still in internal testing.
 */
export function useIsHueloTeam(): boolean {
  const [isTeam, setIsTeam] = useState(false);

  useEffect(() => {
    let active = true;
    supabase.auth.getUser().then(({ data }) => {
      if (!active) return;
      const email = data.user?.email?.toLowerCase() ?? "";
      setIsTeam(email.endsWith("@huelo.co"));
    });
    return () => {
      active = false;
    };
  }, []);

  return isTeam;
}

export default useIsHueloTeam;
